import BackgroundImageCropService from '~/javascripts/services/BackgroundImageCropService';
import FaceApiService from '~/javascripts/services/FaceApiService';
import Modal from '~/javascripts/components/Modal';
import Swiper from 'swiper/bundle';
import { Component } from 'react';

class ProjectPhotos extends Component {
  componentDidMount = () => {
    this.smallPhotosSwiperInstance = new Swiper(this.smallPhotos, {
      effect: 'fade',
      loop: true,
      navigation: {
        nextEl: this.smallPhotosNext,
        prevEl: this.smallPhotosPrev,
      },
    });

    const faceApiService = new FaceApiService();

    faceApiService.loadModels().then(() => {
      const photos = this.smallPhotos.querySelectorAll('.photo');
      photos.forEach((el) => {
        new BackgroundImageCropService(el).setBackgroundProperties();
      });
    });

    document.addEventListener('ModalOpened', this.onModalOpened);
  };

  componentWillUnmount = () => {
    document.removeEventListener('ModalOpened', this.onModalOpened);
  };

  onModalOpened = () => {
    this.largePhotosSwiperInstance = new Swiper(this.largePhotos, {
      controller: {
        control: this.smallPhotosSwiperInstance,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      keyboard: true,
      loop: true,
      initialSlide: this.smallPhotosSwiperInstance.activeIndex - 1,
      navigation: {
        nextEl: this.largePhotosNext,
        prevEl: this.largePhotosPrev,
      },
    });
  };

  setImageBackgroundSize = () => {
    const photos = this.smallPhotos.querySelectorAll('.photo');
    photos.forEach((el) => {
      const img = new Image();
      img.src = el.style.backgroundImage.slice(4, -1).replace(/["']/g, '');
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        faceapi.detectAllFaces(img).then((detections) => {
          if (detections.length) {
            const { x, y, width, height } = detections[0].box;
            const centerX = ((x + width / 2) / img.naturalWidth) * 100;
            const centerY = ((y + height / 2) / img.naturalHeight) * 100;
            el.style.backgroundSize = 'cover';
            el.style.backgroundPosition = `${centerX}% ${centerY}%`;
          } else {
            this.smartCropImg(img, el);
          }
        });
      };
    });
  };

  smartCropImg = (img, el) => {
    smartcrop.crop(img, { width: 462, height: 300 }).then((result) => {
      const crop = result.topCrop;
      const scale = el.clientWidth / crop.width;
      const bgWidth = img.naturalWidth * scale;
      const bgHeight = img.naturalHeight * scale;
      el.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;

      const offsetX = crop.x * scale;
      const offsetY = crop.y * scale;
      el.style.backgroundPosition = `-${offsetX}px -${offsetY}px`;
    });
  };

  render() {
    return (
      <div>
        <div
          className='swiper-container small-photos'
          ref={(el) => (this.smallPhotos = el)}
        >
          <div className='swiper-wrapper' onClick={() => this.modal.toggle()}>
            {this.props.photos.map((photo) => (
              <div
                className='photo swiper-slide'
                key={photo}
                style={{ backgroundImage: `url(${photo})` }}
              />
            ))}
          </div>
          <span
            className='icon cw-icon cw-icon-angle-left'
            ref={(el) => (this.smallPhotosPrev = el)}
          />
          <span
            className='icon cw-icon cw-icon-angle-right'
            ref={(el) => (this.smallPhotosNext = el)}
          />
        </div>

        <Modal
          containerClassName='large-photos'
          modalId='project-photos'
          ref={(el) => (this.modal = el)}
        >
          <div
            className='swiper-container'
            ref={(el) => (this.largePhotos = el)}
          >
            <div className='swiper-wrapper'>
              {this.props.photos.map((photo) => (
                <div
                  className='photo swiper-slide'
                  key={photo}
                  style={{ backgroundImage: `url(${photo})` }}
                />
              ))}
            </div>
          </div>
          <span
            className='icon cw-icon cw-icon-angle-left'
            ref={(el) => (this.largePhotosPrev = el)}
          />
          <span
            className='icon cw-icon cw-icon-angle-right'
            ref={(el) => (this.largePhotosNext = el)}
          />
        </Modal>
      </div>
    );
  }
}

export default ProjectPhotos;
